import { ipoConstants } from '../_constants/ipo.constants';

export const fetchIposStart = (ipoType) => ({
  type: ipoConstants.FETCH_IPOS_START,
  payload: ipoType
});

export const fetchIposSuccess = (data) => ({
  type: ipoConstants.FETCH_IPOS_SUCCESS,
  payload: data
});

export const fetchIposFailure = (errorMessage) => ({
  type: ipoConstants.FETCH_IPOS_FAILURE,
  payload: errorMessage
});

export const toggleDetailModal = () => ({
  type: ipoConstants.TOGGLE_DETAIL_MODAL
});

export const setCurrentDetailModal = (fundCode) => ({
  type: ipoConstants.SET_CURRENT_DETAIL_MODAL,
  payload: fundCode
});

export const updateIPOQueries = (queries) => ({
  type: ipoConstants.UPDATE_IPO_QUERIES,
  payload: queries
});
